



















import { Component, Prop, Vue, Watch } from "vue-property-decorator";

@Component({
  name: "ModalComponent",
  components: {},
})
export default class ModalComponent extends Vue {
  @Prop({ type: String }) public readonly title!: string;
  @Prop({ type: Function }) public readonly onOpen!: () => void;
  @Prop({ type: Function }) public readonly onClose!: () => void;

  public isOpen = null;

  // mounted() {}

  @Watch("isOpen")
  public onIsOpenChange(newValue: boolean, oldVAlue: boolean) {
    if (
      oldVAlue === false &&
      newValue === true &&
      typeof this.onOpen === "function"
    ) {
      this.onOpen();
    } else if (newValue === false && typeof this.onClose === "function") {
      this.onClose();
    }
  }

  public open() {
    this.isOpen = true;
  }

  public close() {
    this.isOpen = false;
  }

  public toggle() {
    this.isOpen = !this.isOpen;
  }
}
